module.exports = __webpack_public_path__ + "static/icon-code.b94c786d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-code.png
// module id = 1014
// module chunks = 2